import React from "react";
import { currencyConfig } from "../../common/currencies";

/**
 * Renders the icon for a currency code — an image when the registry supplies one
 * (GEMS, GEM, RCR), otherwise the text glyph (USD -> "$").
 *
 * Pass the already-resolved display code (see resolveDisplayCurrency); this
 * component does not know about the session.
 *
 * The symbol is returned as bare text (not a wrapping element) unless
 * `symbolClassName` is set — so it merges with the adjacent amount into one flex
 * item and a parent's `gap-*` doesn't insert a space (e.g. "$1.00", not "$ 1.00").
 */
const CurrencyIcon = ({ code, className = "h-4 w-4", symbolClassName = "" }) => {
  const cfg = currencyConfig(code);
  if (cfg.icon) {
    return <img src={cfg.icon} className={`inline-block ${className}`} alt="" />;
  }
  return symbolClassName ? (
    <span className={symbolClassName}>{cfg.symbol}</span>
  ) : (
    cfg.symbol
  );
};

export default CurrencyIcon;
